module.exports = __webpack_public_path__ + "static/Highlight5-e0d5ff19ee7670133ce1352919d1d7b3.png";